import {
	ID_EL_GORDO,
	ID_EURO_MILLIONS,
	ID_POWERBALL,
	ID_MEGASENA,
	ID_UK_LOTTO,
	ID_THUNDERBALL,
	ID_MEGA_MILLIONS,
	ID_LOTTO_AMERICA,
	ID_QUINA,
	ID_LOTTO_FACIL,
	ID_LOTO_FR,
	ID_KENO_FR,
} from './idsLotteries.js'

export const rules_lotteries = {
	euromillions: {
		id: ID_EURO_MILLIONS,
		first_block: {
			min: 1,
			max: 50,
			min_select: 5,
			total: 10,
		},
		last_block: {
			min: 1,
			max: 12,
			min_select: 2,
			total: 5,
		},
		min_count_active: 8,
	},
	el_gordo: {
		id: ID_EL_GORDO,
		first_block: {
			min: 1,
			max: 54,
			min_select: 5,
			total: 11,
		},
		last_block: {
			min: 1,
			max: 9,
			min_select: 1,
			total: 1,
		},
		min_count_active: 7,
	},
	megasena: {
		id: ID_MEGASENA,
		first_block: {
			min: 1,
			max: 60,
			min_select: 6,
			total: 15,
		},
		last_block: null,
		min_count_active: 7,
	},
	uk_lotto: {
		id: ID_UK_LOTTO,
		first_block: {
			min: 1,
			max: 59,
			min_select: 6,
			total: 12,
		},
		last_block: {
			min: 1,
			max: 59,
			min_select: 1,
			total: 1,
		},
		min_count_active: 7,
	},
	lotto_facil: {
		id: ID_LOTTO_FACIL,
		first_block: {
			min: 1,
			max: 25,
			min_select: 15,
			total: 20,
		},
		last_block: null,
		min_count_active: 16,
	},
	quina: {
		id: ID_QUINA,
		first_block: {
			min: 1,
			max: 80,
			min_select: 5,
			total: 15,
		},
		last_block: null,
		min_count_active: 6,
	},
	powerball: {
		id: ID_POWERBALL,
		first_block: {
			min: 1,
			max: 69,
			min_select: 5,
			total: 12,
		},
		last_block: {
			min: 1,
			max: 26,
			min_select: 1,
			total: 1,
		},
		min_count_active: 7,
	},
	mega_millions: {
		id: ID_MEGA_MILLIONS,
		first_block: {
			min: 1,
			max: 70,
			min_select: 5,
			total: 10,
		},
		last_block: {
			min: 1,
			max: 25,
			min_select: 1,
			total: 1,
		},
		min_count_active: 7,
	},
	lotto_america: {
		id: ID_LOTTO_AMERICA,
		first_block: {
			min: 1,
			max: 52,
			min_select: 5,
			total: 10,
		},
		last_block: {
			min: 1,
			max: 10,
			min_select: 1,
			total: 1,
		},
		min_count_active: 7,
	},
	thunderball: {
		id: ID_THUNDERBALL,
		first_block: {
			min: 1,
			max: 39,
			min_select: 5,
			total: 10,
		},
		last_block: {
			min: 1,
			max: 14,
			min_select: 1,
			total: 1,
		},
		min_count_active: 7,
	},
	loto_fr: {
		id: ID_LOTO_FR,
		first_block: {
			min: 1,
			max: 49,
			min_select: 5,
			total: 9,
		},
		last_block: {
			min: 1,
			max: 10,
			min_select: 1,
			total: 1,
		},
		min_count_active: 7,
	},
	keno_fr: {
		id: ID_KENO_FR,
		first_block: {
			min: 1,
			max: 70,
			min_select: 2,
			total: 10,
		},
		last_block: null,
		min_count_active: 3,
	},
}
